module.exports = __webpack_public_path__ + "static/SergeyGorbachev-097842d44303def94aeb43d9f6eba122.jpeg";